export default function BrandStatement() {
  return (
    <section className="py-36 bg-white">
      <div className="max-w-[1280px] mx-auto px-8">
        <div className="flex items-center gap-4 mb-12">
          <span className="block w-10 h-[1px] bg-[#C9A96E]"></span>
          <p className="text-[11px] font-semibold tracking-[0.24em] uppercase text-[#C9A96E]">
            Brand Statement
          </p>
        </div>

        <div className="max-w-[900px]">
          <h2 className="text-[48px] lg:text-[56px] font-light text-[#0A0F1E] leading-[1.2] tracking-[-0.025em]">
            Long-term ownership. Focused growth. <span className="font-semibold">Real-world impact.</span>
          </h2>
        </div>
      </div>
    </section>
  );
}